import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { View } from 'foundations-components/components/View';
import { List } from 'foundations-components/transitional/components/List';
import { jsx as _jsx } from "react/jsx-runtime";
export const WizardList = ({
  children
}) => {
  const {
    isMobile
  } = useMediaQuery();
  return /*#__PURE__*/_jsx(View, {
    maxInlineSize: isMobile ? undefined : '400px',
    children: /*#__PURE__*/_jsx(List, {
      childStyles: {
        marginBlockEnd: '400'
      },
      wrapChildren: true,
      children: children
    })
  });
};